var map = {
	"./10-12-2020-v2/1024/img/Tail_feathers_Normal.png": "017b",
	"./10-12-2020-v2/2048/img/Tail_feathers_Normal.png": "e969",
	"./10-12-2020-v2/512/img/Tail_feathers_Normal.png": "b43a",
	"./10-12-2020-v3/1024/img/Tail_feathers_Normal.png": "1e58",
	"./10-12-2020-v3/2048/img/Tail_feathers_Normal.png": "d243",
	"./10-12-2020-v3/512/img/Tail_feathers_Normal.png": "4b67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6192";